import { createContext } from "react";

export const MainMenuContext = createContext();